export default "__VITE_ASSET__CzH_22PZ__"